import React from "react";
import Layout from "../components/layout";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from "../components/header";
import Welcome from "../components/welcome";
import Gallery from "../components/gallery";
import Admission from "../components/admission";
import Career from "../components/career";
import Contact from "../components/contact";

const IndexPage = () => {
  return (
    <>
      <Layout>
        <Header />
        <Welcome />
        <Gallery />
        <Admission />
        <Career />
        <Contact />
      </Layout>
    </>
  );
};

export default IndexPage;
